export default __webpack_public_path__ + "static/media/icons8-fence.63c8abdd.svg";